var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cms-text',{staticClass:"subtitle",attrs:{"value":`${_vm.prefix}.content`,"props":{variant: 'medium-heading'}}})
}
var staticRenderFns = []

export { render, staticRenderFns }